import { AloftPrice, AloftPriceJSON, isNonEmptyString, orUndefined } from '@aloft/toolkit-shared';

export const extractPrice = (sale: Element): AloftPriceJSON | undefined => {
  try {
    const rawPrice = sale.getAttribute('PropertySalesAmount') ?? undefined;
    if (!isNonEmptyString(rawPrice)) {
      return undefined;
    }
    return orUndefined(AloftPrice.fromDollarLike)(rawPrice)?.toJSON();
  } catch (e: unknown) {
    console.warn('Failed to parse price', e);
    return undefined;
  }
};
